import { render, staticRenderFns } from "./PadErrataPopup.vue?vue&type=template&id=3449248f&"
import script from "./PadErrataPopup.vue?vue&type=script&lang=js&"
export * from "./PadErrataPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports